module.exports = __webpack_public_path__ + "static/media/APP_RisingStar_152x174_4.7c7dcd54.png";